import React from 'react';
import type { BoxProps } from '@withjoy/joykit';
import { Box, styled } from '@withjoy/joykit';
import { animationTransition } from '@shared/joykit/packages/core/utils';

const StyledLink = styled(Box)`
  :hover {
    color: ${props => props.theme.colors.brandYellow5};

    + svg {
      color: ${props => props.theme.colors.brandYellow5};
    }
  }
`;

export const RootLink = (props: BoxProps & React.AnchorHTMLAttributes<'a'>) => {
  return (
    <StyledLink
      as="a"
      whiteSpace="nowrap"
      paddingX="12px"
      fontFamily="Akkurat LL"
      fontWeight={700}
      fontSize={17}
      transition={animationTransition('color')}
      {...props}
    />
  );
};
